import { render, staticRenderFns } from "./SettingHeader.vue?vue&type=template&id=27c96ef5&"
import script from "./SettingHeader.vue?vue&type=script&lang=js&"
export * from "./SettingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c96ef5')) {
      api.createRecord('27c96ef5', component.options)
    } else {
      api.reload('27c96ef5', component.options)
    }
    module.hot.accept("./SettingHeader.vue?vue&type=template&id=27c96ef5&", function () {
      api.rerender('27c96ef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SettingHeader.vue"
export default component.exports